import { render, staticRenderFns } from "./featuredSection.vue?vue&type=template&id=b4b8a004&"
import script from "./featuredSection.vue?vue&type=script&lang=ts&"
export * from "./featuredSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports